<script setup lang="ts">
defineOptions({
  inheritAttrs: false
})

defineProps<{
  headline?: string
  title?: string
  description?: string
}>()

</script>

<template>
  <div
    class="w-full h-full flex relative overflow-hidden bg-gradient-to-tl from-eu-os-purple to-eu-os-blue"
    data-theme="dark"
  >
    <div class="absolute top-5 right-0">
      <img src="/assets/logo-eu-os-no-bg.svg" class="w-100" />
    </div>

    <div class="flex flex-col justify-between flex-1 px-20 py-16">
      <div />

      <div class="flex flex-col gap-5">
        <span
          v-if="headline"
          class="text-3xl font-medium text-eu-os-yellow"
        >
          {{ headline }}
        </span>

        <h1
          v-if="title"
          class="text-6xl font-bold text-highlighted"
        >
          {{ title }}
        </h1>

        <p
          v-if="description"
          class="text-3xl/11 text-muted"
          :style="{ lineClamp: 2, textOverflow: 'ellipsis' }"
        >
          {{ description }}
        </p>
      </div>

      <div class="flex items-center gap-4">
        <div class="h-px flex-1 bg-white" />
        <span class="text-3xl text-white">eu-os.eu</span>
      </div>
    </div>
  </div>
</template>
